"use client";
import { useEffect, useState } from "react";

export default function ProgressBar({
  count,
  total,
}: {
  count: number;
  total: number;
}) {
  const value = (count / total) * 100;
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setProgress(value);
    }, 200); // Delay start slightly

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
      <div
        className="h-full bg-wosm-700 transition-all duration-1000 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
